
import { defineComponent } from 'vue';
import { string } from 'vue-types';

const __default__ = defineComponent({
  name: 'CameraStatusBrief',
  props: {
    color: string().isRequired,
    status: string().isRequired,
    description:string().isRequired,
    type: string().def('circle')
  }
});

import { useCssVars as _useCssVars } from 'vue'
const __injectCSSVars__ = () => {
_useCssVars(_ctx => ({
  "67529659": (_ctx.color)
}))}
const __setup__ = __default__.setup
__default__.setup = __setup__
  ? (props, ctx) => { __injectCSSVars__();return __setup__(props, ctx) }
  : __injectCSSVars__

export default __default__